import { render, staticRenderFns } from "./TypePicker.vue?vue&type=template&id=487c7e4a"
import script from "./TypePicker.vue?vue&type=script&lang=js"
export * from "./TypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports